export const TILE_HEADER_HEIGHT = 24;
